import * as React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import HeroArea from "@containers/hero/layout-06";
import ItSolutionArea from "@containers/it-solution/layout-01";
import ITServiceArea from "@containers/it-service/layout-04";
import ITiServiceArea from "@containers/it-mobile/layout-04";
import ContactArea from "@containers/contact/layout-03";
import CtaArea from "@containers/cta/layout-04";
import Gradation from "@containers/gradation/layout-01";
import DomainArea from "@containers/domain/layout-02";
import Image from "@ui/image";
// 首页
const HomePage = ({ location, data }) => {
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);
    return (
        <Layout location={location}>
            <Seo title="processing" />
            <Header
                transparent
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                    contact: data.site.siteMetadata.contact,
                }}
            />
            <main className="site-wrapper-reveal">
                <HeroArea data={content["hero-section"]} />
                <DomainArea data={content["domain-section"]} />

                <ITiServiceArea data={content["domain-mobile"]} />
                <ItSolutionArea
                    data={{
                        ...content["feature-section"],
                        items: data.features.nodes,
                    }}
                />
                <Image src={data.services.nodes[0].icon.svg.src} />
                <ITServiceArea
                    data={{
                        ...content["service-section"],
                        items: data.services.nodes,
                    }}
                />
                <CtaArea data={content["cta-section"]} />
                <Gradation data={content["gradation-section"]} />

                <ContactArea data={content["contact-section"]} />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query homePageQuery {
        allGeneral {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(title: { eq: "home" }, pageType: { eq: "frontpage" }) {
            content {
                ...PageContent
            }
        }
        features: allItSolution(
            filter: { is_featured: { eq: true } }
            sort: { order: ASC, fields: order }
            limit: 6
        ) {
            nodes {
                ...ItSolutionTwo
            }
        }
        services: allItService(sort: { order: ASC, fields: order }, limit: 7) {
            nodes {
                ...ItServiceOne
            }
        }
    }
`;

HomePage.propTypes = {
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                socials: PropTypes.arrayOf(PropTypes.shape({})),
                contact: PropTypes.shape({}),
            }),
        }),
        features: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        services: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default HomePage;

// <WhatsNewArea data={content["whats-new-section"]}/>
// <PartnerArea data={content["partner-section"]} />
